import { BiPhoneCall, BiChat } from 'react-icons/bi'
import { RiErrorWarningLine } from 'react-icons/ri'
import { HiOutlineMail, HiOutlineClock } from 'react-icons/hi'
import { FaWhatsapp } from 'react-icons/fa'

import styles from '../../pages/Ajuda/styles.module.scss'

interface HelpProps {
    props: { title: string, lists: string[][] }
}

export function HelpComponents(props: HelpProps) {

    return (
        <div className={styles.helpContainer}>
            <div className={styles.titleContainer}>
                <h2>{props.props.title}</h2>
            </div>
            {
                props.props.lists.map((element, key: number) => {
                    if (element[0] === "BiPhoneCall") return (
                        <div key={key} className={styles.optionsContainer}>
                            <BiPhoneCall className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )

                    if (element[0] === "RiErrorWarningLine") return (
                        <div key={key} className={styles.optionsContainer}>
                            <RiErrorWarningLine className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )

                    if (element[0] === "HiOutlineMail") return (
                        <div key={key} className={styles.optionsContainer}>
                            <HiOutlineMail className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )

                    if (element[0] === "FaWhatsapp") return (
                        <div key={key} className={styles.optionsContainer}>
                            <FaWhatsapp className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )

                    if (element[0] === "BiChat") return (
                        <div key={key} className={styles.optionsContainerControle}>
                            <BiChat className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )

                    if (element[0] === "HiOutlineClock") return (
                        <div key={key} className={styles.optionsContainerHorario}>
                            <HiOutlineClock className={styles.icon} />
                            <li>{element[1]}</li>
                        </div>
                    )
                    
                    return ''
                }
                )
            }
        </div>
    )
}

